const modifiedFields = [
  'widgetName',
  'resourceTypeModel',
  'productModel',
  'selectedMetrics',
  'objectModel',
  'showThresholdRange',
  'thresholdEnd',
  'thresholdStart',
  'configItems'
];
const modifiedFieldCustom = {
  configItems: ['chartAttr'],
  chartAttr: ['widget'],
  selectedMetrics:['metricKey']
};
const sortByFields = {};
export default { modifiedFields, modifiedFieldCustom, sortByFields };
